import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface DashboardEmptyStateProps {
	// "plan-review" is the indigo variant and "inspection" is the green one.
	tone: "plan-review" | "inspection";
	icon: LucideIcon;
	title: string;
	description: string;
	actionLabel: string;
	actionRoute: string;
}

const DashboardEmptyState = ({ tone, icon: Icon, title, description, actionLabel, actionRoute }: DashboardEmptyStateProps) => (
	<div className={`des-card des-card-${tone}`}>
		<span className="des-icon">
			<Icon size={32} />
		</span>
		<h2 className="des-title">{title}</h2>
		<p className="des-description">{description}</p>
		<Link to={actionRoute} className="des-action">
			<Plus size={16} />
			<span>{actionLabel}</span>
		</Link>
	</div>
);

export default DashboardEmptyState;
